
import React from 'react';
import { Heart, Lightbulb, Clock } from 'lucide-react';

const ValuesSection = () => {
  return (
    <section className="bg-brand-gray section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Onze kernwaarden</h2>
          <p className="section-subtitle mx-auto">
            Deze principes vormen de basis van ons werk en zie je terug in elke interactie met Afsprakenmaker.be.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-white rounded-lg shadow-sm">
            <div className="text-brand-blue mb-4 mx-auto">
              <Heart size={48} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Vertrouwen</h3>
            <p className="text-gray-600">
              Wij vertegenwoordigen jouw bedrijf aan de telefoon. Dat vertrouwen nemen we uiterst serieus en schenden we nooit. Integriteit staat voorop in alles wat we doen.
            </p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-lg shadow-sm">
            <div className="text-brand-blue mb-4 mx-auto">
              <Lightbulb size={48} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Resultaat</h3>
            <p className="text-gray-600">
              We zijn pas tevreden als we tastbare resultaten boeken voor jouw bedrijf. Geen vage beloftes maar concrete afspraken en meetbare impact op je omzetgroei.
            </p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-lg shadow-sm">
            <div className="text-brand-blue mb-4 mx-auto">
              <Clock size={48} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Groei</h3>
            <p className="text-gray-600">
              We geloven in constante verbetering en ontwikkeling, zowel voor onszelf als voor onze klanten. Elke dag worden we beter in wat we doen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
